package com.jingfangpai.user.model

import kotlinx.serialization.Serializable
import org.jooq.PermissionType

@Serializable
class UserAuthData {
    var id:String?=""
    var userName:String?=""
    var mobilePhone:String? = ""
    var departmentName:String?=""
    var departmentId:String?=""
    var organizationId:String?=""
    var organizationName:String?=""
    var loa:Set<String>? = mutableSetOf()
    var jwt:String?=""

    fun getPermissions():Array<PermissionType>{
        return arrayOf()//this.permission?.let { PermissionUtils.parsePermission(it) }?:arrayOf()
    }
}